module.exports = __webpack_public_path__ + "static/BrandonGrotesque-BoldItalic-6440345a916055cf12a4b5e3a3e2c1e4.woff";